<template>
  <div class="collector-page">
    <Row>
      <i-Col span="4">
        <Select v-model="groupname" :value="groupname" filterable>
          <Option v-for="item in group" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </i-Col>
      <i-Col span="6">
        <Input v-model="search" :placeholder="$t('Product.productNo')">
           <Button slot="append" icon="ios-search" @click="handleSearch()"></Button>
           <Button slot="append" icon="refresh" @click="handleReset()"></Button>
        </Input>
      </i-Col>
    </Row>
    <br>
    <Table class="collector-table" highlight-row stripe border :columns="columns" v-if="check === false" :data="datas"></Table>
    <Table class="collector-table" highlight-row stripe border :columns="columns" v-if="check === true" :data="temp"></Table>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Collector',
  data () {
    return {
      columns: [
        { type: 'index', title: this.$t('monitor.Collector.index'), width: 65 },
        {
          title: this.$t('monitor.Collector.status1'),
          key: 'status1',
          width: 100,
          render: (h, params) => {
            return h('Tag', {
              props: {
                type: 'dot',
                color: this.datas[params.index].status1
              }
            })
          }
        },
        { title: this.$t('monitor.Collector.name'), key: 'name', sortable: true },
        { title: this.$t('monitor.Collector.group'), key: 'group', sortable: true },
        { title: this.$t('monitor.Collector.rpm'), key: 'rpm', width: 100 },
        { title: this.$t('monitor.Collector.status'), key: 'status3', width: 100 },
        { title: this.$t('monitor.Collector.error'), key: 'status2' },
        { title: this.$t('monitor.Collector.worker'), key: 'worker' },
        { title: this.$t('monitor.Collector.workType'), key: 'workType' },
        { title: this.$t('monitor.Collector.orderNo'),
          key: 'orderProductdata',
          render: (h, params) => {
            if (this.datas[params.index].orderProductdata !== null) {
              let tag = ''
              if (this.datas[params.index].orderProductdata.length > 0) {
                tag += this.datas[params.index].orderProductdata[0].OrderNo + '  /  '
              }
              if (this.datas[params.index].orderProductdata.length > 0) {
                tag += this.datas[params.index].orderProductdata[0].ProductNo
              }
              return h('Poptip', {
                props: {
                  trigger: 'hover',
                  placement: 'left'
                }
              }, [
                h('Tag', tag),
                h('div', {
                  slot: 'content'
                }, [
                  h('table', [
                    h('tbody', this.datas[params.index].orderProductdata.map(item => {
                      return h('tr', [
                        h('td', item.OrderNo + '  /  ' + item.ProductNo)
                      ])
                    }))
                  ])
                ])
              ])
            }
          }
        }
      ],
      datas: [],
      timer: 0,
      Producting: [],
      group: [],
      SystemCode: '',
      groupname: '',
      search: '',
      temp: [],
      check: false,
      Productinglength: 0
      // orderProduct: [],
      // orderProductlength: 0
    }
  },
  methods: {
    loadData () {
      Api.system.get().then(res => {
        this.SystemCode = res.company.systemCode
        // console.log(this.SystemCode)
      })
      let code = '{"systemcode":"' + this.SystemCode + '"}'
      Api.monitor.producting(code).then(res => {
        if (res.datas === null) {
          this.Productinglength = 0
        } else {
          this.Productinglength = this.Producting.length
          this.Producting = res.datas
        }
      })
      Api.collectorGroup.list().then(res => {
        this.group = res.collectorGroups
      })
      // Api.order.list().then(res => {
      //   if (res.datas === null) {
      //     this.orderProductlength = 0
      //   } else {
      //     this.orderProduct = res.orderInfos
      //   }
      // })
      Api.monitor.collectors().then(res => {
        this.datas = res.collectors
        for (let i = 0; i < this.datas.length; i++) {
          this.datas[i].group = ''
          // console.log(this.group)
          if (this.group !== undefined) {
            for (let j = 0; j < this.group.length; j++) {
              for (let k = 0; k < this.group[j].collectors.length; k++) {
                if (this.datas[i].id === this.group[j].collectors[k]) {
                  this.datas[i].group += this.group[j].name + '  '
                }
              }
            }
          }
          this.datas[i].status2 = ''
          let status = this.datas[i].status
          if (status.indexOf('正常') !== -1) {
            this.datas[i].status1 = 'green'
          } else if (status.indexOf('离线') !== -1) {
            this.datas[i].rpm = 0
            this.datas[i].status1 = 'red'
          } else if (status.indexOf('未知') !== -1) {
            this.datas[i].rpm = 0
            this.datas[i].status1 = 'yellow'
          }
          if (status.indexOf('经纱故障') !== -1) {
            this.datas[i].status2 += this.$t('monitor.Collector.warp')
          }
          if (status.indexOf('纬纱故障') !== -1) {
            this.datas[i].status2 += this.$t('monitor.Collector.weft')
          }
          if (status.indexOf('底线故障') !== -1) {
            this.datas[i].status2 += this.$t('monitor.Collector.thread')
          }
          if (status.indexOf('卷取故障') !== -1) {
            this.datas[i].status2 += this.$t('monitor.Collector.roll')
          }
          let d = []
          // if (this.datas[i].status === this.$t('monitor.Collector.timeout')) {
          //   this.datas[i].rpm = 0
          //   this.datas[i].status = this.$t('monitor.Collector.timeout')
          // }
          if (this.Productinglength === 0) {
            if (this.datas[i].rpm > 0) {
              this.datas[i].status3 = this.$t('monitor.Collector.trial')
            } else {
              this.datas[i].status3 = this.$t('monitor.Collector.standby')
            }
          } else {
            for (let j = 0; j < this.Producting.length; j++) {
              // if (this.Producting[j].deviceid === this.datas[i].id) {
              if (this.Producting[j].deviceNo === this.datas[i].deviceNo) {
                d.push({
                  OrderNo: this.Producting[j].orderNo,
                  ProductNo: this.Producting[j].productNo
                })
                // console.log(d, '1')
                if (this.datas[i].rpm > 0) {
                  this.datas[i].status3 = this.$t('monitor.Collector.run')
                  break
                } else {
                  this.datas[i].status3 = this.$t('monitor.Collector.stop')
                  break
                }
              } else if (j + 1 === this.Producting.length) {
                if (this.datas[i].rpm > 0) {
                  this.datas[i].status3 = this.$t('monitor.Collector.trial')
                } else {
                  this.datas[i].status3 = this.$t('monitor.Collector.standby')
                }
              }
            }
          }
          this.datas[i].orderProductdata = d
          // console.log(this.datas[i], d, '2')
          if (this.datas[i].rpm === 9999) {
            this.datas[i].rpm = 0
          }
        }
      })
      this.temp = []
      if (this.check === true) {
        for (let i = 0; i < this.datas.length; i++) {
          let p = this.datas[i]
          if (this.groupname !== '' && this.search !== '') {
            if (p.group.toLowerCase().indexOf(this.groupname.toLowerCase()) !== -1 && p.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
              this.temp.push(p)
            }
          } else {
            if (this.groupname !== '') {
              if (p.group.toLowerCase().indexOf(this.groupname.toLowerCase()) !== -1) {
                this.temp.push(p)
              }
            }
            if (this.search !== '') {
              if (p.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
                this.temp.push(p)
              }
            }
          }
        }
      }
    },
    handleSearch () {
      this.check = true
      this.loadData()
    },
    handleReset () {
      this.check = false
      this.groupname = ''
      this.search = ''
      this.loadData()
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.loadData()
    }, 2000)
  },
  destroyed () {
    clearInterval(this.timer)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => { vm.loadData() })
  }
}
</script>
<style scoped>
  .collector-page {
    padding: 10px;
  }
  /* .info {
    width: 33.33333%
  } */
  .collector-table {
    margin-top: 20px;
  }
</style>





// WEBPACK FOOTER //
// Collector.vue?348f4201